function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { assign, setup, fromPromise } from 'xstate';
// --- 타입 변환 헬퍼 (이전과 동일) ---
var mapApiSectionDraftToApiSection = function(draftSection) {
    var _draftSection_lectures;
    if (!draftSection || draftSection.id == null) return undefined;
    var _draftSection_lectures_map_filter;
    return {
        id: String(draftSection.id),
        title: draftSection.title,
        lectures: (_draftSection_lectures_map_filter = (_draftSection_lectures = draftSection.lectures) === null || _draftSection_lectures === void 0 ? void 0 : _draftSection_lectures.map(function(l) {
            if (l.id == null) return null;
            return {
                id: String(l.id),
                title: l.title || '',
                order: l.order ? String(l.order) : '',
                contentType: l.contentType,
                platformSupport: l.platformSupport,
                duration: l.duration !== null && l.duration !== undefined ? String(l.duration) : undefined,
                isCompleted: false
            };
        }).filter(Boolean)) !== null && _draftSection_lectures_map_filter !== void 0 ? _draftSection_lectures_map_filter : []
    };
};
// URL 접두사 정의
var VITE_API_URL = process.env['VITE_API_URL'] || 'http://localhost:8080';
var MARKDOWN_URL_PREFIX = "".concat(VITE_API_URL, "/api/media/file/");
export var courseLoaderMachine = setup({
    types: {
        context: {},
        events: {},
        input: {}
    },
    actors: {
        fetchCourseActor: fromPromise(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var input, courseDataResponse, enrichedCourseData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, section, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, lecture, fullMarkdownUrl, markdownContent, e, err, err;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            input = param.input;
                            console.log("[courseLoaderMachine] fetchCourseActor fetching main course data for courseId: ".concat(input.courseId));
                            return [
                                4,
                                input.deps.fetchCourseApi(input.courseId)
                            ];
                        case 1:
                            courseDataResponse = _state.sent();
                            if (!courseDataResponse) {
                                console.error("[courseLoaderMachine] fetchCourseActor: fetchCourseApi resolved with undefined/null data.");
                                throw new Error('API returned no data for course.');
                            }
                            console.log("[courseLoaderMachine] fetchCourseActor successfully fetched main course data.");
                            // CourseDataResponse를 EnrichedCourseDraftDetailResponse로 변환 (타입 캐스팅 및 깊은 복사)
                            enrichedCourseData = JSON.parse(JSON.stringify(courseDataResponse));
                            if (!enrichedCourseData.sections) return [
                                3,
                                17
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                15,
                                16,
                                17
                            ]);
                            _iterator = enrichedCourseData.sections[Symbol.iterator]();
                            _state.label = 3;
                        case 3:
                            if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                                3,
                                14
                            ];
                            section = _step.value;
                            if (!section.lectures) return [
                                3,
                                13
                            ];
                            _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            _state.label = 4;
                        case 4:
                            _state.trys.push([
                                4,
                                11,
                                12,
                                13
                            ]);
                            _iterator1 = section.lectures[Symbol.iterator]();
                            _state.label = 5;
                        case 5:
                            if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                3,
                                10
                            ];
                            lecture = _step1.value;
                            if (!lecture.markdownUrl) return [
                                3,
                                9
                            ];
                            fullMarkdownUrl = "".concat(MARKDOWN_URL_PREFIX).concat(lecture.markdownUrl);
                            _state.label = 6;
                        case 6:
                            _state.trys.push([
                                6,
                                8,
                                ,
                                9
                            ]);
                            console.log("[courseLoaderMachine] Fetching markdown for lecture ID ".concat(lecture.id, ", URL: ").concat(fullMarkdownUrl));
                            return [
                                4,
                                input.deps.fetchMarkdownContentApi(fullMarkdownUrl)
                            ];
                        case 7:
                            markdownContent = _state.sent();
                            lecture.fetchedMarkdownContent = markdownContent;
                            console.log("[courseLoaderMachine] Successfully fetched markdown for lecture ID ".concat(lecture.id));
                            return [
                                3,
                                9
                            ];
                        case 8:
                            e = _state.sent();
                            console.warn("[courseLoaderMachine] Failed to fetch markdown content for lecture ID ".concat(lecture.id, ", URL ").concat(fullMarkdownUrl, ":"), e);
                            lecture.fetchedMarkdownContent = ''; // 오류 발생 시 빈 문자열로 처리 또는 undefined 유지
                            return [
                                3,
                                9
                            ];
                        case 9:
                            _iteratorNormalCompletion1 = true;
                            return [
                                3,
                                5
                            ];
                        case 10:
                            return [
                                3,
                                13
                            ];
                        case 11:
                            err = _state.sent();
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                            return [
                                3,
                                13
                            ];
                        case 12:
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                            return [
                                7
                            ];
                        case 13:
                            _iteratorNormalCompletion = true;
                            return [
                                3,
                                3
                            ];
                        case 14:
                            return [
                                3,
                                17
                            ];
                        case 15:
                            err = _state.sent();
                            _didIteratorError = true;
                            _iteratorError = err;
                            return [
                                3,
                                17
                            ];
                        case 16:
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                            return [
                                7
                            ];
                        case 17:
                            console.log("[courseLoaderMachine] fetchCourseActor finished processing markdown, returning enriched data.");
                            return [
                                2,
                                enrichedCourseData
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }())
    },
    actions: {
        determineTargetId: assign({
            targetCourseIdToLoad: function(param) {
                var event = param.event;
                var e = event;
                return e.currentDraftId || e.routeCourseId || 'new';
            },
            routeCourseId: function(param) {
                var event = param.event;
                return event.routeCourseId;
            },
            currentDraftId: function(param) {
                var event = param.event;
                return event.currentDraftId;
            }
        }),
        clearError: assign({
            error: null
        }),
        dispatchResetFormForNew: function(param) {
            var context = param.context;
            context.dependencies.resetFormForNewCourseAction();
            context.dependencies.initializeCurriculumSectionsAction([], 'new', null);
        },
        assignOperationIdAsNew: assign({
            operationId: 'new'
        }),
        assignOperationIdFromTarget: assign({
            operationId: function(param) {
                var context = param.context;
                return context.targetCourseIdToLoad || null;
            }
        }),
        dispatchSetFetchError: function(param) {
            var context = param.context;
            if (context.error) context.dependencies.setFetchErrorAction(context.error);
        },
        setGlobalFetchLoadingTrue: function(param) {
            var context = param.context;
            context.dependencies.setFetchLoadingAction(true);
        },
        setGlobalFetchLoadingFalse: function(param) {
            var context = param.context;
            context.dependencies.setFetchLoadingAction(false);
        }
    },
    guards: {
        isTargetNew: function(param) {
            var context = param.context, event = param.event;
            return context.targetCourseIdToLoad === 'new';
        },
        isAlreadyLoadingOrLoaded: function(param) {
            var context = param.context, event = param.event;
            var _context_dependencies_getCourseDataFromStore;
            var storeLoading = context.dependencies.getFetchLoadingFromStore();
            var storeCourseId = (_context_dependencies_getCourseDataFromStore = context.dependencies.getCourseDataFromStore()) === null || _context_dependencies_getCourseDataFromStore === void 0 ? void 0 : _context_dependencies_getCourseDataFromStore.id;
            return context.operationId === context.targetCourseIdToLoad && (storeLoading || storeCourseId === context.targetCourseIdToLoad);
        }
    }
}).createMachine({
    id: 'courseLoader',
    context: function(param) {
        var input = param.input;
        return {
            routeCourseId: input.initialRouteId,
            currentDraftId: input.initialDraftId,
            targetCourseIdToLoad: undefined,
            loadedCourseData: null,
            error: null,
            operationId: null,
            dependencies: input.dependencies
        };
    },
    initial: 'idle',
    states: {
        idle: {
            on: {
                LOAD_COURSE: {
                    target: 'determiningTarget',
                    actions: [
                        'determineTargetId',
                        'clearError'
                    ]
                }
            }
        },
        determiningTarget: {
            always: [
                {
                    guard: 'isTargetNew',
                    target: 'initializingNew'
                },
                {
                    target: 'checkingExisting'
                }
            ]
        },
        initializingNew: {
            entry: [
                'dispatchResetFormForNew',
                'assignOperationIdAsNew',
                'setGlobalFetchLoadingFalse'
            ],
            always: 'idle'
        },
        checkingExisting: {
            always: [
                {
                    guard: 'isAlreadyLoadingOrLoaded',
                    target: 'idle'
                },
                {
                    target: 'loading'
                }
            ]
        },
        loading: {
            entry: [
                'assignOperationIdFromTarget',
                'setGlobalFetchLoadingTrue'
            ],
            invoke: {
                id: 'fetchCourseApiActor',
                src: 'fetchCourseActor',
                input: function(param) {
                    var context = param.context;
                    return {
                        courseId: context.targetCourseIdToLoad,
                        deps: context.dependencies
                    };
                },
                onDone: {
                    target: 'loaded',
                    actions: assign(function(param) {
                        var context = param.context, event = param.event;
                        console.log("[courseLoaderMachine] onDone action entered. Event output received.");
                        var apiData = event.output;
                        if (!apiData) {
                            console.error("[courseLoaderMachine] onDone: apiData is missing or undefined!");
                            return _object_spread_props(_object_spread({}, context), {
                                error: "Invalid data from API (undefined response in event.output)",
                                loadedCourseData: null
                            });
                        }
                        console.log("[courseLoaderMachine] onDone: apiData is valid. ID:", apiData.id);
                        if (apiData.id == null) {
                            console.error("[courseLoaderMachine] onDone: apiData.id is null!");
                            return _object_spread_props(_object_spread({}, context), {
                                error: "Invalid course data from API (missing ID)",
                                loadedCourseData: null
                            });
                        }
                        console.log("[courseLoaderMachine] onDone: apiData.id is valid.");
                        try {
                            var validApiSections = apiData.sections || [];
                            console.log("[courseLoaderMachine] onDone: validApiSections count:", validApiSections.length);
                            var _validApiSections_map_filter;
                            var mappedSectionsForCourseData = (_validApiSections_map_filter = validApiSections.map(mapApiSectionDraftToApiSection).filter(Boolean)) !== null && _validApiSections_map_filter !== void 0 ? _validApiSections_map_filter : [];
                            console.log("[courseLoaderMachine] onDone: mappedSectionsForCourseData count:", mappedSectionsForCourseData.length);
                            var _apiData_isPremium;
                            var courseDataResult = {
                                id: String(apiData.id),
                                title: apiData.title || '',
                                description: apiData.description === null ? undefined : apiData.description,
                                level: apiData.level || 'BEGINNER',
                                instructor: apiData.instructor,
                                price: apiData.price,
                                thumbnailUrl: apiData.thumbnailUrl,
                                isPremium: (_apiData_isPremium = apiData.isPremium) !== null && _apiData_isPremium !== void 0 ? _apiData_isPremium : false,
                                isPublished: apiData.isPublished || false,
                                sections: mappedSectionsForCourseData,
                                createdAt: apiData.createdAt ? new Date(apiData.createdAt).getTime() : null,
                                updatedAt: apiData.updatedAt ? new Date(apiData.updatedAt).getTime() : null
                            };
                            console.log("[courseLoaderMachine] onDone: courseDataResult mapped.");
                            if (!context.dependencies || !context.dependencies.setLoadedCourseDataAction || !context.dependencies.initializeCurriculumSectionsAction) {
                                console.error("[courseLoaderMachine] onDone: Dependencies or required actions are missing!", context.dependencies);
                                return _object_spread_props(_object_spread({}, context), {
                                    error: "Internal error: Machine dependencies missing.",
                                    loadedCourseData: null
                                });
                            }
                            context.dependencies.setLoadedCourseDataAction({
                                courseData: courseDataResult,
                                title: courseDataResult.title || '',
                                description: courseDataResult.description || '',
                                level: courseDataResult.level || 'BEGINNER',
                                thumbnailUrl: courseDataResult.thumbnailUrl || null
                            });
                            console.log("[courseLoaderMachine] onDone: setLoadedCourseDataAction called.");
                            var storeSections = mapApiSectionsToStoreSections(apiData.sections || []);
                            console.log("[courseLoaderMachine] onDone: storeSections mapped, count:", storeSections.length);
                            var serverTimestamp = null;
                            if (apiData.updatedAt) {
                                var parsedDate = new Date(apiData.updatedAt);
                                if (!isNaN(parsedDate.getTime())) {
                                    serverTimestamp = parsedDate.getTime();
                                } else {
                                    console.warn("[courseLoaderMachine] Invalid date format for apiData.updatedAt:", apiData.updatedAt);
                                }
                            }
                            console.log("[courseLoaderMachine] onDone: Calling initializeCurriculumSectionsAction. serverTimestamp:", serverTimestamp);
                            context.dependencies.initializeCurriculumSectionsAction(storeSections, String(apiData.id), serverTimestamp);
                            console.log("[courseLoaderMachine] onDone: initializeCurriculumSectionsAction FINISHED.");
                            return _object_spread_props(_object_spread({}, context), {
                                loadedCourseData: courseDataResult,
                                error: null
                            });
                        } catch (e) {
                            console.error("[courseLoaderMachine] onDone: Error during data processing or dependency call:", e);
                            return _object_spread_props(_object_spread({}, context), {
                                error: "Error processing course data: ".concat(e.message),
                                loadedCourseData: null
                            });
                        }
                    })
                },
                onError: {
                    target: 'failed',
                    actions: assign(function(param) {
                        var context = param.context, event = param.event;
                        var errMessage = '데이터 로딩 중 알 수 없는 오류 발생';
                        if (_instanceof(event.error, Error)) {
                            errMessage = event.error.message;
                        } else if (typeof event.error === 'string') {
                            errMessage = event.error;
                        } else if (event.error && typeof event.error.message === 'string') {
                            errMessage = event.error.message;
                        }
                        console.error("[courseLoaderMachine] onError: assignLoadError:", errMessage, "Raw error:", event.error);
                        return _object_spread_props(_object_spread({}, context), {
                            loadedCourseData: null,
                            error: errMessage
                        });
                    })
                }
            },
            exit: 'setGlobalFetchLoadingFalse'
        },
        loaded: {
            on: {
                LOAD_COURSE: {
                    target: 'determiningTarget',
                    actions: [
                        'determineTargetId',
                        'clearError'
                    ]
                }
            }
        },
        failed: {
            entry: [
                'dispatchSetFetchError',
                'setGlobalFetchLoadingFalse'
            ],
            on: {
                RETRY_LOAD: 'loading',
                LOAD_COURSE: {
                    target: 'determiningTarget',
                    actions: [
                        'determineTargetId',
                        'clearError'
                    ]
                }
            }
        }
    }
});
// ... mapApiSectionsToStoreSections 함수 수정 ...
var mapApiSectionsToStoreSections = function(apiSections) {
    if (!apiSections) return [];
    return apiSections.map(function(apiSection) {
        var _apiSection_lectures;
        var sectionId = apiSection.id || "temp-section-".concat(Math.random().toString(36).substr(2, 9));
        return {
            id: String(sectionId),
            title: apiSection.title || '',
            order: apiSection.order !== undefined ? parseInt(String(apiSection.order)) : undefined,
            lessons: ((_apiSection_lectures = apiSection.lectures) === null || _apiSection_lectures === void 0 ? void 0 : _apiSection_lectures.map(function(apiLecture) {
                var _apiLecture_videoUrl;
                var lessonId = apiLecture.id || "temp-lesson-".concat(Math.random().toString(36).substr(2, 9));
                return {
                    id: String(lessonId),
                    title: apiLecture.title || '',
                    order: apiLecture.order !== undefined && apiLecture.order !== null ? parseInt(String(apiLecture.order), 10) : undefined,
                    contentType: apiLecture.contentType,
                    platformSupport: apiLecture.platformSupport,
                    duration: apiLecture.duration !== undefined && apiLecture.duration !== null ? parseInt(String(apiLecture.duration), 10) : undefined,
                    markdownUrl: apiLecture.markdownUrl ? "".concat(MARKDOWN_URL_PREFIX).concat(apiLecture.markdownUrl) : undefined,
                    videoUrl: (_apiLecture_videoUrl = apiLecture.videoUrl) === null || _apiLecture_videoUrl === void 0 ? void 0 : _apiLecture_videoUrl.toString(),
                    markdown: apiLecture.fetchedMarkdownContent || ''
                };
            })) || []
        };
    }).filter(Boolean);
};
